import SideMenu from "../sideMenu";
import { useLocation } from "react-router-dom";
import DashboardHeader from "../topbar";
import { makeSideBarActive } from "../../utils/EllowUtils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { useEffect, useState } from 'react';
import { EditorState, convertToRaw, convertFromRaw, Modifier, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import AppliedCandidates from './appliedCandidates'
import mixpanelData, { viewedpageMixpanel } from "../../utils/mixpanel";
import { updateNotificationStatus } from "../../components/noticationTab/services";
import {  getPositionsDetails, getAppliedCandidate} from './services'

function CrPositionDetails() {

  const menu = makeSideBarActive(CONSTANTS.crSideMenu, 0)
  const [companyPositionName, setCompanyPositioName] = useState<string>()
  const [Company, setCompany] = useState<string>()
  const [jobsId, setJobsId] = useState<any>()


  const location = useLocation();
  const jobId: any = localStorage.getItem('PositionsJobId') || location.state.jobId || ''
  const positionName: any = localStorage.getItem('PositionsPositionName') || location?.state.positionName || ''
  const companyName: any = localStorage.getItem('PositionsCompanyName') || location.state.companyName || ''
  const loginId = localStorage.getItem('loginId')
  const { notificationsId }: any = location.state || ''

  const [positionData, setPositionData] = useState<any>()
  const [customerId, setCustomerId] = useState<string>('')
  const [allocatedToId, setAllocatedToId] = useState<any>()
  const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())
  const [appliedResources, setAppliedResources] = useState([])
  const [jobStatus, setJobStatus] = useState<number>()
  const [jobMetadata, setJobMetadata] = useState<{
    resourceCount: number, experienceRange: number, contractDuration: string, contractStartDate: number, minimumBudget: number, maximumBudget: number,
    billingType: string, jobRole: { id: number, name: string }, coreSkills: [{ skillId: number, skillName: string }], otherSkills: [{ skillId: number, skillName: string }],
    closedCount: number, jobDescription: string, priority: number, lossCount: number, supportingDocument: string, locationPreference: any
  }>({
    resourceCount: 0, experienceRange: 0, contractDuration: "", contractStartDate: 0, minimumBudget: 0, maximumBudget: 0,
    billingType: "", jobRole: { id: 0, name: "" }, coreSkills: [{ skillId: 0, skillName: "" }], otherSkills: [{ skillId: 0, skillName: "" }],
    closedCount: 0, jobDescription: "", priority: 5, lossCount: 0, supportingDocument: "", locationPreference: {}

  })

  const updateNotification = (notificationId: any) => {

    updateNotificationStatus(notificationId).then((response: any) => {
      if (response && response.status === "success") {
      }
    })
  }

  useEffect(() => {
    if (notificationsId != '') {
      updateNotification(notificationsId);
    }
    setCompanyPositioName(positionName)
    setCompany(companyName)
    setJobsId(jobId)
    getPositionDetails(jobId)
    getAppliedCandidates(jobId)
    viewedpageMixpanel()

  }, [])

  let BreadcrumsValues = ['CRPositions', companyPositionName + ' - ' + Company]

  const getPositionDetails = (jobId: string) => {
    getPositionsDetails(jobId).then(
      (response) => {
        if (response && response.status === 1) {
          setPositionData(response.data[0])
          setAllocatedToId(response.data[0].allocated_to)
          setJobMetadata(response.data[0].job_metadata)
          setJobStatus(response.data[0].job_status)
          setCustomerId(response.data[0].company_id)
        }
      }
    );
  }

  const getAppliedCandidates = (jobId: string) => {
    getAppliedCandidate(jobId, loginId).then((resp) => {
      if (resp && resp.status === 1) {
        setAppliedResources(resp.data.data)
      }
    })
  }

  const pageChange = (data: any) => {

  }

  const pageSize = (pageSize: any, pageNumber: number) => {

  }

  const convert = (item: any) => {

    if (item) {
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== item) {
        try {
          let abd = draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(item))).getCurrentContent()))
          let strippedHtml = abd.replace(/<[^>]+>/g, '');
          return strippedHtml

        }
        catch (e) {
          return item
        }

      }
    }
  }

  const positionDetails = () => {
    setTimeout(() => {
      getPositionDetails(jobId)
    }, 3000)
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          searchChange={undefined}
          jobId={jobsId}
          companyName={companyName}
          jobStatus={jobStatus}
          priority={jobMetadata.priority}
          positionData={positionData}
        />
        < AppliedCandidates jobStatus={jobStatus} jobMetadata={jobMetadata} pageChange={pageChange} pageSize={pageSize} convert={convert} appliedResources={appliedResources} jobId={jobsId} companyName={companyName} getAppliedCandidates={() => getAppliedCandidates(jobsId)}  customerId={customerId} getPositionDetails={positionDetails} allocatedToId={allocatedToId}/>
      </div>
    </section>
  );
}
export default CrPositionDetails;